
import { computed, defineComponent, inject, PropType, reactive, ref } from 'vue'

export default defineComponent({
  name: 'EditableBlockSelect',
  emits: ['update:modelValue'],
  props: {
    options: {
      type: Array as PropType<Array<{ label: string, value: string } | string>>,
      default: () => ([]),
    },
    emitValue: {
      type: Boolean,
      default: false,
    },
    modelValue: {
      type: [String, Number, Array, Object],
    },
    label: {
      type: String
    },
    attributes: {
      type: Object
    },
    readonly: {
      type: Boolean
    }
  },

  setup (props, { emit }) {
    const optionsRef = ref(props.options)

    const inputState = reactive({
      label: computed(() => props.label),
      value: computed({ get: () => props.modelValue, set: (newValue) => emit('update:modelValue', newValue) })
    })

    const editing = inject('editing', false)

    const filterFn = (val, update) => {
      if (val === '') { update(() => {
          optionsRef.value = props.options
        })
        return
      }

      update(() => {
        const needle = val.toLowerCase()
        optionsRef.value = props.options.filter(v => {
          if (typeof v === 'string') {
            return v.toLowerCase().indexOf(needle) > -1
          } else if (typeof v === 'object' && typeof v.label === 'string') {
            return v.label.toLowerCase().indexOf(needle) > -1
          } else {
            return []
          }
        })
      })
    }

    return {
      optionsRef,
      inputState,
      filterFn,
      editing
    }
  }
})
